import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';


import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';

import { AuthGuardService } from './shared/authguard/auth-guard.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthorsComponent } from './authors/authors.component';
import { CalcComponent } from './calc/calc.component';
import { UsersComponent } from './users/users.component';
import { AccountantComponent} from './accountant/accountant.component';

import { AuthInterceptor } from '../app/shared/authguard/auth-guard.interceptor';
import { UserService } from './shared/user/user-service.service';
import { AuthorsService } from './shared/authors/authors.service';
import { CoreService } from './shared/core/core.service';
import { CalcService } from './shared/calc/calc.service';

import {MaterialModule} from 'src/material-module';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { DatepickerOverviewComponent, MY_FORMATS } from './components/datepicker-overview/datepicker-overview.component';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { AuthorsListComponent } from './components/authors-list/authors-list.component';
import { CalcDetailComponent } from './calc-detail/calc-detail.component';
import { ModalWindowComponent } from './components/modal-window/modal-window.component';
import { UserAddComponent } from './user-add/user-add.component';
import { RoleComponent } from './components/role/role.component';
import { RightsTemplateComponent } from './components/rights-template/rights-template.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { AddNoteAuthorComponent } from './components/add-note-author/add-note-author.component';
import { DetailUserComponent } from './components/detail-user/detail-user.component';
import { CalculationsComponent } from './reports/calculations/calculations.component';
import { YearsComponent } from './components/data/years/years.component';
import { MonthsComponent } from './components/data/months/months.component';
import { ConfigFactory, ConfigService, API_BASE_URL } from './shared/config.service';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FooterComponent } from './footer/footer.component';

const appRoutes: Routes = [
  {path: 'login', component : LoginComponent},
  {path: '', component : HomeComponent, canActivate: [AuthGuardService]
  , children: [
    {path: 'calc', component : CalcComponent, canActivate: [AuthGuardService]},
    { path: 'detail/:id', component: CalcDetailComponent },
    {path: 'authors', component : AuthorsComponent, canActivate: [AuthGuardService]},
    {path: 'users', component : UsersComponent, canActivate: [AuthGuardService]},
    {path: 'accountant', component : AccountantComponent, canActivate: [AuthGuardService]},
    {path: 'windowmodal', component : ModalWindowComponent, canActivate: [AuthGuardService]},
    {path: 'newuser', component : UserAddComponent, canActivate: [AuthGuardService]},
    {path: 'account', component : MyAccountComponent, canActivate: [AuthGuardService]},
    {path: 'addnote', component : AddNoteAuthorComponent, canActivate: [AuthGuardService]},
    {path: 'detailUser', component : DetailUserComponent, canActivate: [AuthGuardService]},
    {path: 'calc/:id', component : CalcComponent, canActivate: [AuthGuardService]},
    {path: 'reports', component : CalculationsComponent, canActivate: [AuthGuardService]},
  ],
},

];

// adding bootstrap via
// https://medium.com/@beeman/tutorial-styling-angular-cli-v6-apps-with-bootstrap-8d4f8ea5adae
//

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    AuthorsComponent,
    CalcComponent,
    UsersComponent,
    AccountantComponent,
    DatepickerOverviewComponent,
    AuthorsListComponent,
    CalcDetailComponent,
    ModalWindowComponent,
    UserAddComponent,
    RoleComponent,
    RightsTemplateComponent,
    MyAccountComponent,
    AddNoteAuthorComponent,
    DetailUserComponent,
    CalculationsComponent,
    YearsComponent,
    MonthsComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    BrowserAnimationsModule
  ],
 providers: [
   UserService,
   AuthorsService,
   CoreService,
   CalcService,
   AuthorsService,
   AuthGuardService,
   ConfigService,
   {
    provide : HTTP_INTERCEPTORS,
    useClass : AuthInterceptor,
    multi : true
    },
  {
    provide: MAT_DATE_LOCALE, useValue: 'pl-PL'
  }
  ,
  {
     provide: MAT_DATE_FORMATS, useValue: MY_FORMATS
   },
   {provide: LocationStrategy, useClass: HashLocationStrategy},
   { provide: 'CONFIGPATH', useValue: '/assets/config.json' },
   { provide: 'APIURLVAR', useValue: 'API_BASE_URL' },
   {
    provide: API_BASE_URL, useFactory: ConfigFactory,
    deps: [ConfigService, 'CONFIGPATH', 'APIURLVAR']
  }
  ],
  bootstrap: [AppComponent],
  entryComponents: [DatepickerOverviewComponent],
})


export class AppModule { }


platformBrowserDynamic().bootstrapModule(AppModule);
